const React = require('react');
const connect = require('react-redux/dist/react-redux.min.js').connect;
const ReduxStore = require('./redux/reduxStore.jsx.js');
const AjaxFunctions = require('./ajaxFunctions');
const Utils = require('./utils');
const MultiLineTextField = require('./components/commonControls.jsx').MultiLineTextField;
const Dragula = require('react-dragula');
const CardRow = require('./components/cardRow.jsx').CardRow;
const CardModal = require('./components/cardModal.jsx').CardModal;
const ToastAlert = require('./components/toastAlert');
const NoteCardCreation = require('./components/noteCardCreation.jsx').NoteCardCreation;
import PortfolioManager from './components/portfolioManager.jsx';

const SharedConstants = require('../../../shared/sharedConstants');
const Constants = require('./constants');

import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LoadingScreen } from './components/loadingScreen.jsx';
import Toastr from 'toastr';
import { Grid } from '@material-ui/core';

class PortfolioBase extends React.Component{
   constructor(props) {
      super(props);
      this.state = {
         idPortfolio: Utils.getParameterByName('idPortfolio', window.location.href),
         loading: true,
      }
   }

   componentDidMount(){
      AjaxFunctions.getPortfolioById(this.state.idPortfolio).then(d => {
         Promise.all([
            AjaxFunctions.getUserPortfolios(),
            AjaxFunctions.getSynthesisTemplates(),
         ]).then(data => {
            ReduxStore.store.dispatch(ReduxStore.PortfolioFunctions.setCurPortfolio(d));
            ReduxStore.store.dispatch(ReduxStore.PortfolioFunctions.setPortfolioList(data[0]));
            ReduxStore.store.dispatch(ReduxStore.PortfolioFunctions.setSynthesisTemplates(data[1]));
            this.setState({ loading: false });
         }).catch(err => {
            throw err;
         })
      }).catch(err => {
         Toastr.options = {
            preventDuplicates: true,
            preventOpenDuplicates: true,
            positionClass: 'toast-bottom-full-width',
         }
         Toastr.error(err);
      });
   }

   async moveIndexInPortfolio(oldIndex, newIndex){
      try {
         await AjaxFunctions.moveIndexInPortfolio(this.state.idPortfolio, oldIndex, newIndex);
         await this.props.getUpdatedPortfolioData(this.state.idPortfolio);
      }
      catch(err){
         ToastAlert.error(err);
      }
   }

   async removeCardFromPortfolio(card){
      try {
         await AjaxFunctions.removeCardFromPortfolio(this.state.idPortfolio, card.id, card.cardType, card.index);
         await this.props.getUpdatedPortfolioData(this.state.idPortfolio);
      }
      catch(err){
         ToastAlert.error(err);
      }
   }

   render() {
      let isCurUserOwner = this.props.portfolio.idOwner === parseInt(globals.idUser);  
      let tooltipTitle = (title) => {
         return (
            <React.Fragment>
               <div style={{ fontSize: SharedConstants.TooltipValue.FontSize, lineHeight: SharedConstants.TooltipValue.LineHeight }}>
                  {title}
               </div>
            </React.Fragment>
         )
      };   

      if (this.state.loading) {
         return <LoadingScreen />
      }
      return (
         <Grid container spacing={2}>
            <Grid className='left-bar' item lg={3}>
               <PortfolioManager
                  backLink={'/portfolioList'}
                  addTabText={`Add ${String.fromCharCode(181)}Pubs`}
               />
            </Grid>
            <Grid item lg={9}> 
               <div>
                  <h2>
                     {this.props.portfolio.name}
                     <Tooltip title={tooltipTitle("Export to DOCX")}>
                        <a className={'btn-portfolio-export'} href={'portfolio/exportAsDocX?idPortfolio=' + this.props.portfolio.id}>
                           <IconButton aria-label="Export to DOCX">
                              <FontAwesomeIcon icon={['far',"file-word"]} />
                           </IconButton>
                        </a>
                     </Tooltip>
                     <Tooltip title={tooltipTitle("Export to TXT")}>
                        <a className={'btn-portfolio-export'} href={'portfolio/exportAsTxt?idPortfolio=' + this.props.portfolio.id}>
                           <IconButton aria-label="Export to TXT">
                              <FontAwesomeIcon icon={['far',"file-alt"]} />
                           </IconButton>
                        </a>
                     </Tooltip>
                  </h2>
                  <h5>
                     Create notes to organize your portfolio. {isCurUserOwner ? 'All portfolio elements can be re-arranged by clicking and dragging.' : ''}
                  </h5>
                  <NoteCardCreation
                     idPortfolio={this.state.idPortfolio}
                     onNoteCardCreation={() => this.props.getUpdatedPortfolioData(this.props.portfolio.id)}
                  />
                  <ListPane
                     isCurUserOwner={isCurUserOwner}
                     deckList={this.props.deckList}
                     cards={this.props.portfolio.items}
                     removeCardFromPortfolio={(card) => this.removeCardFromPortfolio(card)}
                     moveIndexInPortfolio={(oldIndex, newIndex) => this.moveIndexInPortfolio(oldIndex, newIndex)}
                     linkFunction={cardData => this.props.cardLinkFunction(cardData)}
                     idPortfolio={this.props.portfolio.id}
                  />
                  <CardModal 
                     returnUrl={window.location.pathname}
                     searchUrl={'?idPortfolio=' + this.props.portfolio.id}
                  />
               </div>
            </Grid>
         </Grid>
      );
   }
}

const mapListViewStateToProps = (state) => {
   return {
      portfolio: state.PortfolioReducer.curPortfolio,
      curEvidenceCard: state.EvidenceCardReducer.curCard,
      curGreySpaceCard: state.GreySpaceCardReducer.curCard
   }
};

const mapListViewDispatchToProps = (dispatch) => {
   return {
      getUpdatedPortfolioData: async (idPortfolio) => {
         let portfolioData = await AjaxFunctions.getUserPortfolios();
         dispatch(ReduxStore.PortfolioFunctions.setPortfolioList(portfolioData));
         let curPortfolioData = await AjaxFunctions.getPortfolioById(idPortfolio);
         dispatch(ReduxStore.PortfolioFunctions.setCurPortfolio(curPortfolioData));
      },
      cardLinkFunction: (cardData) => {
         if(cardData.cardType === SharedConstants.CardType.Evidence) {
            dispatch(ReduxStore.EvidenceCardFunctions.setCurrentCard(cardData));
         }
         else if(cardData.cardType === SharedConstants.CardType.Reasoning)
            dispatch(ReduxStore.GreySpaceCardFunctions.setCurrentCard(cardData));

      },
   }
};

export default connect(
   mapListViewStateToProps,
   mapListViewDispatchToProps
)(PortfolioBase);

let drake = null;

class ListPane extends React.Component{
   constructor(props) {
      super(props);
   }

   componentDidUpdate(){
      if(drake) drake.destroy();
      let container = document.getElementById('portfolioCardRows');
      if(this.props.isCurUserOwner) {
         drake = Dragula([container]);
         drake.on('drop', (data1, data2, data3, data4) => {
            //data1 is the element, data4 is the element that it is being dropped before, hence the -1
            let oldIndex = parseInt(data1.id.substr(1));
            let newIndex = -1;
            if (data4) {
               newIndex = parseInt(data4.id.substr(1));
               //if we are moving to a higher index value, we want the new index to be one below the next sibling
               //if we are moving to a lower index value, we want the new index value to be the sibling's old value.
               if (newIndex > oldIndex) newIndex--;
            }
            else {
               newIndex = this.props.cards[this.props.cards.length - 1].index;
            }
            console.log(oldIndex + '_' + newIndex);
            this.props.moveIndexInPortfolio(oldIndex, newIndex);
         })
      }
   }

   render() {
      if(!this.props.cards){
         console.log('card list does not exist');
         return(<div />);
      }
      else if(this.props.cards.length === 0){
         return(<div />);
      }

      let cards = this.props.cards.slice();

      let cardRows = cards.map((card, index) => {
         return (
            <CardRow
               cardType={card.cardType}
               card={card}
               key={card.cardType + '_' + card.id + '_' + card.index}
               linkFunction={() => this.props.linkFunction(card)}
               linkBase={window.location.pathname + '?idPortfolio=' + this.props.idPortfolio}
               deckList={this.props.deckList}
               removeCardFromPortfolio={this.props.removeCardFromPortfolio}
               allApproved={true}
               rowNumber={index + 1}
            />
         )
      });

      return (
         <div id='portfolioCardRows'>
            {cardRows}
         </div>
      );
   }
}

